module.exports = __webpack_public_path__ + "./images/5a07db5417c7f210272182e097728b7e.jpg";